/* unplugin-vue-components disabled */import { render } from "./VipAgreements.vue?vue&type=template&id=29db3470&scoped=true"
import script from "./VipAgreements.vue?vue&type=script&lang=js"
export * from "./VipAgreements.vue?vue&type=script&lang=js"

import "./VipAgreements.vue?vue&type=style&index=0&id=29db3470&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29db3470"]])

export default __exports__